import { Button } from "antd"

export const DownloadButton = ({ handleDownload, imageUrl }) => {
    return (
        <Button key="download" type="primary" onClick={handleDownload(imageUrl)} className='primary-btn px-4 py-1 rounded-5 font-medium'>
            Download
        </Button>
    )
}